export const MANUAL_SOURCE = 'MANUAL'
export const MANUAL_ID = 'bank-info-manual'
